import { ExternalWalletFundingDefaultChainFromJSON, ExternalWalletFundingDefaultChainToJSON } from './ExternalWalletFundingDefaultChain.js';
import { ExternalWalletFundingDefaultCurrencyFromJSON, ExternalWalletFundingDefaultCurrencyToJSON } from './ExternalWalletFundingDefaultCurrency.js';
import { FundingExternalWalletsMinAmountFromJSON, FundingExternalWalletsMinAmountToJSON } from './FundingExternalWalletsMinAmount.js';

/* tslint:disable */
function FundingExternalWalletsFromJSON(json) {
    return FundingExternalWalletsFromJSONTyped(json);
}
function FundingExternalWalletsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'enabled': json['enabled'],
        'defaultCurrency': ExternalWalletFundingDefaultCurrencyFromJSON(json['defaultCurrency']),
        'minAmount': FundingExternalWalletsMinAmountFromJSON(json['minAmount']),
        'defaultChain': ExternalWalletFundingDefaultChainFromJSON(json['defaultChain']),
        'defaultNetwork': json['defaultNetwork'],
    };
}
function FundingExternalWalletsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'enabled': value.enabled,
        'defaultCurrency': ExternalWalletFundingDefaultCurrencyToJSON(value.defaultCurrency),
        'minAmount': FundingExternalWalletsMinAmountToJSON(value.minAmount),
        'defaultChain': ExternalWalletFundingDefaultChainToJSON(value.defaultChain),
        'defaultNetwork': value.defaultNetwork,
    };
}

export { FundingExternalWalletsFromJSON, FundingExternalWalletsFromJSONTyped, FundingExternalWalletsToJSON };
